import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {
 
  RiStore2Line,
  RiMedicineBottleLine,
  RiUserFollowLine,
  RiPriceTag3Line,
  RiImageLine,
  RiArchiveLine,
  RiCloseLine,
  RiMenuFoldLine,
  RiMenuUnfoldLine,
  RiFileList3Line,
  RiFileTextLine,
  RiLayoutFill,
  RiArrowDownSLine,
  RiLogoutBoxLine
} from 'react-icons/ri';
import { GiHamburgerMenu } from "react-icons/gi";
import { useAuth } from '../contexts/AuthContext';
import { logoutUtils } from '../utils/logoutUtils';
import './AdminDashboard.css';
import { FaArrowLeft } from "react-icons/fa";
import AddMedicine from './AddMedicine/AddMedicine';
import PrescriptionManagement from './Prescription/PrescriptionManagement';
import MedicineManagement from './Medicine/MedicineManagement';
import FormPage from './DoctorAppointment/FormPage';
import OrderManagement from './OrderManagement/OrderManagement';
import LabTestManagement from './LabTestManagement/LabTestManagement';



function EmployeeDashboard() {
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const [selectedOption, setSelectedOption] = useState({ category: null, option: null });
  const [formVisibility, setFormVisibility] = useState({
    addMedicine: false,
    manageMedicines: false,
    prescriptionManagement: false,
    formPage: false,
    orderManagement: false,
    labTestManagement: false,
  });
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const menuRef = useRef(null);

  const handleClick = (category, option) => {
    // If no specific option is provided, use the first option from the menu item
    const menuItem = menuOptions.find(item => item.category === category);
    const defaultOption = menuItem?.options?.[0]?.value;
    const finalOption = option || defaultOption;

    setSelectedOption({ category, option: finalOption });
    setFormVisibility({
      addMedicine: category === 'medicine' && (finalOption === 'single' || !finalOption),
      manageMedicines: category === 'medicine' && finalOption === 'manage',
      prescriptionManagement: category === 'prescriptions' && (finalOption === 'manage' || !finalOption),
      formPage: category === 'appointment' && (finalOption === 'appointment' || !finalOption),
      orderManagement: category === 'orders' && (finalOption === 'manage' || !finalOption),
      labTestManagement: category === 'labTest' && (finalOption === 'manage' || !finalOption),
    });
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // console.log(event.target, menuRef.current);
      if (window.innerWidth <= 768 && !event.target.closest(".sidebar")) {
        setIsSidebarOpen(false);
    }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
}, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleLogout = () => {
    logoutUtils.confirmLogout(() => {
      logoutUtils.performLogout(navigate, logout);
    });
  };

  const menuOptions = [
    {
      label: 'Medicine',
      icon: RiMedicineBottleLine,
      options: [
        { label: 'Add Medicine', value: 'single' },
        { label: 'Manage Medicines', value: 'manage' }
      ],
      category: 'medicine',
    },
    {
      label: 'Prescriptions',
      icon: RiFileList3Line,
      category: 'prescriptions',
      options: [
        { label: 'Manage Prescriptions', value: 'manage' }
      ],
    },
    {
      label: 'Orders',
      icon: RiFileList3Line,
      category: 'orders',
      options: [
        { label: 'Manage Orders', value: 'manage' }
      ],
    },
    {
      label: 'Lab Tests',
      icon: RiFileList3Line,
      category: 'labTest',
      options: [
        { label: 'Manage Lab Tests', value: 'manage' }
      ],
    },
    {
      label: 'Appointment',
      icon: RiFileList3Line,
      category: 'appointment',
      options: [
        { label: 'Manage Appointment', value: 'appointment' }
      ],
    },
  ];

  return (
    <div className={`admin-dashboard ${!isSidebarOpen ? 'sidebar-collapsed' : ''}`} ref={menuRef}>

      <motion.div
        className={`sidebar ${!isSidebarOpen ? 'collapsed' : ''}`}
        initial={{ x: -300 }}
        animate={{ x: 0 }}
        transition={{ type: "spring", stiffness: 100 }}
      >
        <div className="sidebar-header">
          <h2 style={{ color: "white" }}>Employee <br /> Dashboard</h2>
          
          {/* User Info Section */}
          <div className="user-info" style={{
            padding: '10px',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderRadius: '8px',
            margin: '10px 0',
            fontSize: '14px',
            color: 'white'
          }}>
            <div style={{ fontWeight: 'bold', marginBottom: '5px' }}>
              Welcome, {user?.name || 'Employee'}
            </div>
            <div style={{ fontSize: '12px', opacity: 0.8 }}>
              Role: {user?.role || 'Employee'}
            </div>
          </div>
          
          {/* Logout Button */}
          <motion.button
            className="logout-btn"
            onClick={handleLogout}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            style={{
              width: '100%',
              padding: '10px 15px',
              backgroundColor: '#dc3545',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: 'bold',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              marginBottom: '20px',
              transition: 'all 0.3s ease'
            }}
          >
            <RiLogoutBoxLine style={{ fontSize: '16px' }} />
            Logout
          </motion.button>
        </div>
        <motion.button
          className="sidebar-toggle"

          onClick={toggleSidebar}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.3 }}
        >
          {isSidebarOpen ? (
            <GiHamburgerMenu style={{ transition: 'transform 0.3s' }} />
          ) : (
            <GiHamburgerMenu style={{ transition: 'transform 0.3s' }} />
          )}
        </motion.button>

        <ul>
          {menuOptions.map((menuItem) => (
            <motion.li
              key={menuItem.category}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <button
                className={`sidebar-btn ${selectedOption.category === menuItem.category ? 'active' : ''}`}
                onClick={() => handleClick(menuItem.category)}
              >
                <div className="sidebar-btn-content">
                  <div className="btn-left">
                    <menuItem.icon className="menu-icon" />
                    <span>{menuItem.label}</span>
                  </div>
                  {menuItem.options && (
                    <RiArrowDownSLine
                      className={`dropdown-arrow ${selectedOption.category === menuItem.category ? 'rotated' : ''
                        }`}
                    />
                  )}
                </div>
              </button>
              <AnimatePresence>
                {selectedOption.category === menuItem.category && menuItem.options && (
                  <motion.ul
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: "auto" }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.2 }}
                    className="submenu"
                  >
                    {menuItem.options.map((option) => (
                      <motion.li
                        key={option.value}
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <button
                          className={`sub-menu-btn ${selectedOption.category === menuItem.category &&
                            selectedOption.option === option.value
                            ? 'active'
                            : ''
                            }`}
                          onClick={() => handleClick(menuItem.category, option.value)}
                        >
                          {option.label} <span>+</span>
                        </button>
                      </motion.li>
                    ))}
                  </motion.ul>
                )}
              </AnimatePresence>
            </motion.li>
          ))}
        </ul>
      </motion.div>

      <motion.div
        className={`content ${!isSidebarOpen ? 'expanded' : ''}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        <h3>Welcome to the Employee Dashboard</h3>
        <p>Select an option from the sidebar to perform an operation.</p>

        <AnimatePresence mode="wait">
          {Object.entries(formVisibility).map(([key, isVisible]) =>
            isVisible && (
              <motion.div
                key={key}
                className={`${key}-section form-section`}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.2 }}
              >
                <motion.button
                  className="close-btn"
                  whileHover={{ scale: 1.1 }}
                  whileTap={{ scale: 0.9 }}
                  onClick={() =>
                    setFormVisibility({ ...formVisibility, [key]: false })
                  }
                >
                  <RiCloseLine />
                </motion.button>
                {/* Render the appropriate component based on the key */}
                {key === 'addMedicine' && <AddMedicine />}
                {key === 'manageMedicines' && <MedicineManagement />}
                {key === 'prescriptionManagement' && <PrescriptionManagement />}
                {key === 'formPage' && <FormPage />}
                {key === 'orderManagement' && <OrderManagement />}
                {key === 'labTestManagement' && <LabTestManagement/>}
               

              </motion.div>
            )
          )}
        </AnimatePresence>
      </motion.div>
    </div>
  );
}

export default EmployeeDashboard;